import Konva from 'konva';

import { resetPanelShowForPanelPage } from '../../store/senAppProjects.action';
import { DrawScale } from '../draw_scale';
import { DrawFence } from '../fence/DrawFence';
import { SC_Input } from '../input/SC_Input';
import * as konva from '../konva/getCanvas';
import { MountingSystem } from '../mountsys/MountingSystem';
import { MountingType } from '../mountsys/MountingType';
import { Sol50 } from '../mountsys/Sol50';
import { Sol50Integrated } from '../mountsys/Sol50Integrated';
import { Sol50OnRoof } from '../mountsys/Sol50OnRoof';
import { Hip } from '../roof/Hip';
import { PartialHip } from '../roof/PartialHip';
import { Rectangular } from '../roof/Rectangular';
import { RoofShape } from '../roof/RoofShape';
import { RoofType } from '../roof/RoofType';
import { SC_Beam } from '../roof/SC_Beam';
import { Global } from '../utilities/global';
import {
    layerEvents,
    stageEvents,
} from './eventBinding';
import { ModGroup } from './ModGroup';
import { ModList } from './ModList';
import { Modul } from './Modul';
import SnapPanel from './panelssnap';
import genaratePanelSave, { saveNonUsableAreas } from './savePanelDetails';

declare var turf: any;

export class DrawRoofForPanel {

    static stage: any;
    static layerScale: Konva.Layer;
    static layerRoof: Konva.Layer;
    static layerBeam: Konva.Layer;
    static layerPanel: Konva.Layer;
    // static scrollLayers: Konva.Layer;
    static subframeGroup: Konva.Group = new Konva.Group({
        draggable: false,
        opacity: 0
    });
    static panelGroup: Konva.Group = new Konva.Group({
        draggable: false,
        opacity: 1
    });
    static elipseGroup: Konva.Group = new Konva.Group({
        draggable: false,
        opacity: 1
    });
    static shapeGroup: Konva.Group = new Konva.Group({
        draggable: false,
        opacity: 1
    });

    static nRoofHeight: number;
    static nRoofWidth: number;
    static currentScale: number = 0.4;
    // on selection group or panel true
    static isGroupClicked = false;
    static isPanelClicked = false;
    static isMouseDown = false;
    static isGroupSelected = false;
    static isPanelSelected = false;
    static stopSelectionPanelsWhileDrag = true;
    static isSubframeEnabled = false;
    static isViewPanelsEnabled = true;
    static enableDragLayout = true;

    static isEscapeKeyPressed = false;

    static isZoomed = false;


    // static isSelected = false;

    static onInit(scaleId: string) {
        this.nRoofHeight = RoofShape.getCurrentRoofHeight();
        this.nRoofWidth = RoofShape.getCurrentRoofWidth();
        const position: any = document.getElementById('roof_panel_canvas_container');
        this.stage = konva.getCanvasStage({
            container: scaleId,
            width: position.offsetWidth,  //window.screen.width * 0.75,
            height: position.offsetHeight, //window.screen.height * 0.85,
            id: 'stagepanel',
            draggable: false
        });
        ;
        // this.layerScale = konva.getCanvasLayer();
        this.layerRoof = konva.getCanvasLayer();
        this.layerBeam = konva.getCanvasLayer();
        this.layerPanel = konva.getCanvasLayer();
        // this.scrollLayers = konva.getCanvasLayer();
        this.layerPanel.add(this.subframeGroup);
        this.layerPanel.add(this.panelGroup);
        this.layerPanel.add(this.shapeGroup);
        this.layerPanel.add(this.elipseGroup);
        // Bind events
        // layerEvents(this.layerPanel);
        // stageEvents(this.stage);

        new DrawScale().drawScale(this.stage, this.layerRoof);
        // this.stage.add(this.layerRoof);
        // this.layerRoof.draw();
        this.roofDrawing();
        this.stage.add(this.layerRoof);
        this.layerRoof.draw();
        this.stage.add(this.layerBeam);
        this.stage.add(this.layerPanel);
        this.getScaleValue(position);
        this.stage.scaleX(this.currentScale);
        this.stage.scaleY(this.currentScale);
        // this.setupStageSelection();
        this.stage.draw();
        this.zoomInOutOnMouseWheel();
        this.setupForPanelDropOnCanvas();
        this.deleteButtonEventBind(this.stage);
        ModGroup.groupSelectionEventBinding();
        // setTimeout(()=>{
        //     genaratePanelSave();
        // }, 2000)
    }

    static getScaleValue(position: any) {
        const scaleX = position.offsetWidth / (RoofShape.getCurrentRoofWidth() + 150);
        const scaleY = position.offsetHeight / (RoofShape.getCurrentRoofHeight() + 150);
        //console.log(position.offsetWidth ,position.offsetHeight , RoofShape.getCurrentRoofWidth() + 150 ,RoofShape.getCurrentRoofHeight() + 150,scaleX,scaleY);
        this.currentScale = scaleX > scaleY ? scaleY : scaleX;
    }

    static setDefaultScaleToStage() {
        const position: any = document.getElementById('roof_panel_canvas_container');
        this.getScaleValue(position);
        this.stage.scaleX(this.currentScale);
        this.stage.scaleY(this.currentScale);
    }

    static singlePanelDelete() {
        let deletedId = ModList.currentSelectedPanel.getAttrs().id;
        // _.remove(ModList.listOfModules, function (panel: any): boolean {
        //     if (deletedId == panel.panelId) {
        //         return true;
        //     }
        //     return false;
        // });
        ModList.currentSelectedPanel.destroy();
        DrawRoofForPanel.layerPanel.batchDraw();
        // console.log(ModList.listOfModules.length)
        ModList.currentSelectedPanel = null;
    }

    static deleteButtonEventBind(stage: any) {
        var container = stage.container();
        // make it focusable
        container.tabIndex = 1;
        // focus it
        // also stage will be in focus on its click
        container.focus();
        container.addEventListener('keydown', function (e: any) {
            if (e.key == 'Delete') {
                DrawFence.storeObj.dispatch(resetPanelShowForPanelPage({ resetPanelShow: false }));
                let isPanelDeleted = false;
                if (ModList.currentSelectedPanel) {
                    // console.log(ModList.listOfModules.length)
                    DrawRoofForPanel.singlePanelDelete();
                    isPanelDeleted = true;
                }
                if (ModGroup.currentSelectedGroup) {
                    ModGroup.currentSelectedGroup.destroy();
                    ModGroup.currentSelectedGroup = null;
                    ModList.currentSelectedPanel = null;
                    isPanelDeleted = true;
                }
                if (isPanelDeleted) {
                    Modul.isPanelMoved = true;
                    DrawRoofForPanel.layerPanel.batchDraw();
                    setTimeout(() => {
                        genaratePanelSave();
                        DrawRoofForPanel.layerPanel.batchDraw();
                    }, 500);
                }
                const tr: any = DrawRoofForPanel.layerPanel.find('.shapeTransform');
                if (tr && tr.length > 0) {
                    DrawFence.currentSelectedShape = null;
                    tr.forEach((t: any) => {
                        t.getNode().destroy();
                    });
                    DrawFence.removeTransformNodes();
                    DrawFence.FenceCount--;
                    saveNonUsableAreas();

                    //clear obstructions text if present
                    DrawFence.clearObstructionTextIfAlreadyPresent();

                    DrawRoofForPanel.layerPanel.batchDraw();
                }
                // if (DrawFence.currentSelectedShape) {
                //     DrawFence.currentSelectedShape.destroy();
                //     DrawRoofForPanel.layerPanel.draw();
                //     DrawFence.currentSelectedShape = null;
                //     DrawFence.removeTransformNodes();
                //     DrawFence.FenceCount--;
                //     saveNonUsableAreas();
                // }
            }
        });
    }

    //draw roof based on selection of Roof shape
    static roofDrawing() {
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            new Rectangular().drawPult(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            new Rectangular().drawSattel(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            new Hip().drawHip(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            new Rectangular().drawSched(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            new PartialHip().drawPartialHip(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            // Rectangular.drawMansard();
        }
        if (SC_Input.iRoofType != RoofType.TRAPEZOIDAL && SC_Input.iMountingType != MountingType.DIRECT) {
            if (SC_Input.iMountSys != MountingSystem.SOL50_PREM_IN) {
                SC_Beam.drawBeam(this.layerBeam);
                this.layerBeam.draw();
            }
        }
        if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType != MountingType.DIRECT) {
            SC_Beam.drawBeam(this.layerBeam);
            this.layerBeam.draw();
        }
        // let w: any, h: any, s: any = this.currentScale;
        // setTimeout(() => {
        //     const container = document.getElementById("panel_canvas_stage");
        //     const scrollCanvas = document.getElementById("roof_panel_canvas_container");
        //     if (container && scrollCanvas) {
        //         scrollCanvas.style.width = w ? w + 'px' : (RoofShape.getCurrentRoofWidth() * this.currentScale) + 65 + 'px';
        //         scrollCanvas.style.height = h ? h + 'px' : (RoofShape.getCurrentRoofHeight() * this.currentScale) + 65 + 'px';
        //         // if (scrollCanvas.offsetWidth > container.offsetWidth) {
        //             // new CanvasScroll().horizontalBar(this.stage, this.scrollLayers, [this.layerRoof, this.layerPanel, this.layerBeam], RoofShape.getCurrentRoofWidth());
        //         // }
        //         // if (scrollCanvas.offsetHeight > container.offsetHeight) {
        //             new CanvasScroll().verticalBar(this.stage, this.scrollLayers, [this.layerRoof, this.layerPanel, this.layerBeam], RoofShape.getCurrentRoofHeight());
        //         // }
        //     }
        //     }, 100);
    }

    // canvas stage Zoom in and Zoom out functionality
    static zoomInOut(sing: string): number {
        //console.log(this.stage.scaleX() , 'entered')
        //console.log('DrawFence.isTransformEnabled',DrawFence.isTransformEnabled);
        let diff = 0.01;
        const step = 0.08;
        if (sing == '-') {
            this.stage.scaleX(this.currentScale - step);
            this.stage.scaleY(this.currentScale - step);
            diff = -0.01;
        } else {
            this.stage.scaleX(this.currentScale + step);
            this.stage.scaleY(this.currentScale + step);
            diff = 0.01;
            const con = document.getElementById('roof_panel_canvas_container');
            // if (con) con.style.overflowX = "scroll";
        }
        this.stage.draw();
        this.currentScale = this.stage.scaleX();
        //DrawFence.isTransformEnabled = true;
        DrawRoofForPanel.getCurrentsize();
        DrawRoofForPanel.isZoomed = true;
        return diff;
    }

    static getCurrentsize() {
        // setTimeout(() => {
        var obj: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        //console.log('obj1',obj)
        if (obj && obj.length > 0) {
            //console.log('obj[0].getClientRect()',obj[0].getClientRect());
            Global.panelClientRectDetailsForElipseError = obj[0].getClientRect();
            Global.singlePanelSize = obj[0].getClientRect();
        }
        // }, 500);
    }

    // based on mouse wheel movement calling zoomInOut
    static zoomInOutOnMouseWheel() {
        let oldScale = this.currentScale;
        this.stage.on('wheel', (event: any) => {
            event.evt.preventDefault();
            var oldScale = this.stage.scaleX();
            // console.log('oldScale',oldScale);
            const scaleBy = 1.1;
            var pointer: any = this.stage.getPointerPosition();

            // console.log(pointer);

            var mousePointTo = {
                x: (pointer.x - this.stage.x()) / oldScale,
                y: (pointer.y - this.stage.y()) / oldScale,
            };

            var newScale = event.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;
            // console.log('newScale',newScale)
            this.stage.scale({ x: newScale, y: newScale });
            DrawRoofForPanel.currentScale = newScale;
            var newPos = {
                x: pointer.x - mousePointTo.x * newScale,
                y: pointer.y - mousePointTo.y * newScale,
            };
            this.stage.position(newPos);
            this.stage.batchDraw();
            DrawRoofForPanel.getCurrentsize();
            DrawRoofForPanel.isZoomed = true;
            // var areas: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
            //    if (areas && areas.length > 0) {
            //     areas.forEach((i: any) => {
            // DrawFence.updateShapeDetails(i);
            //     });
            // }

        });
    }

    // bind events of stage for selection
    static setupStageSelection() {
    }

    // bind event for on panel drop
    static setupForPanelDropOnCanvas() {
        var ModWidth = SC_Input.nModWidth / 10;
        var ModHeight = SC_Input.nModHeight / 10;
        var tempOnDragMove: any = null;
        var shape: any = null;
        var foundMatch = false;

        var con = this.stage.container();

        //add mosue cursor on mouse move for whole container (on panel drag and drop)
        var roofpanelcon = document.getElementById('roof_panel_container');
        roofpanelcon?.addEventListener('mousemove', (e: any) => {

            if (Global.dragDropModules.allowPanelonRoof && roofpanelcon) {
                roofpanelcon.classList.add('sen-cursor-move');
            } else {
                if (roofpanelcon) {
                    roofpanelcon.classList.remove('sen-cursor-move');
                }
            }
        });


        // while panels draging on roof - dragover event
        con.addEventListener('mousemove', (e: any) => {


            if (Global.dragDropModules.allowPanelonRoof) {


                // console.log('entered');
                e.preventDefault();
                this.stage.setPointersPositions(e);
                if (Global.dragDropModules.portrait) {
                    ModWidth = SC_Input.nModWidth / 10;
                    ModHeight = SC_Input.nModHeight / 10;
                } else {
                    ModHeight = SC_Input.nModWidth / 10;
                    ModWidth = SC_Input.nModHeight / 10;
                }
                //console.log('ModWidth,ModHeight',SC_Input.nModWidth,SC_Input.nModHeight);

                var mousePos: any = this.stage.getPointerPosition();
                var x1 = mousePos.x - DrawRoofForPanel.stage.x();
                var y1 = mousePos.y - DrawRoofForPanel.stage.y();

                if (tempOnDragMove == null) {
                    var rows = Global.dragDropModules.rows;
                    var columns = Global.dragDropModules.columns;
                    var width = (columns - 1) * (ModWidth + 0.7) + ModWidth;
                    var height = (rows - 1) * (ModHeight + 2.4) + ModHeight;
                    tempOnDragMove = new Konva.Group({
                        x: (x1) * 1 / this.currentScale - ModWidth / 2,
                        y: (y1) * 1 / this.currentScale - ModHeight / 2,
                    });
                    // console.log('tempOnDragMove',tempOnDragMove);
                    let p = 0, q = 0;
                    const arr: any[] = [];
                    for (let j = 0; j < columns; j++) {
                        p = j * (ModWidth + Sol50.nHorizontalAbstand), q = 0;
                        for (let i = 0; i < rows; i++) {
                            q = i * (ModHeight + Sol50.nVertikalAbstand);
                            arr.push({ x: p, y: q });
                        }
                    }

                    for (let j = 0; j < columns; j++) {
                        for (let i = 0; i < rows; i++) {
                            const imageObj = new Image();
                            imageObj.onload = function () {
                                const v = arr.pop();
                                const panelmg = new Konva.Image({
                                    image: imageObj,
                                    width: ModWidth,
                                    height: ModHeight,
                                    x: v.x,
                                    y: v.y,
                                });
                                // console.log('panelmg tempOnDragMove',tempOnDragMove);
                                tempOnDragMove.add(panelmg);
                                // console.log('panelmg tempOnDragMove',tempOnDragMove);
                                if (panelmg) {
                                    panelmg.draw();
                                }
                            };
                            imageObj.src = document.baseURI + '/assets/images/mono.jpg';
                        }
                    }

                    this.layerPanel.add(tempOnDragMove);

                } else {
                    tempOnDragMove.setX(x1 * 1 / this.currentScale - ModWidth / 2);
                    tempOnDragMove.setY(y1 * 1 / this.currentScale - ModHeight / 2);
                }


                if (tempOnDragMove) {

                    const p = {
                        'x': tempOnDragMove.getX(),
                        'y': tempOnDragMove.getY(),
                        'width': ModWidth,
                        'height': ModHeight,

                    };

                    foundMatch = false;
                    let listOfGroups = ModList.listOfGroups;
                    //console.log(listOfGroups,'listOfGroups');
                    if (listOfGroups && listOfGroups.length > 1) {
                        listOfGroups.forEach((i: any) => {
                            //G or H ,F area drop on panel
                            //console.log('panel drag and snap from right side drag panel');
                            // selected panel x and y positions on move and height and width for a single panel is h,w
                            // i - group to which the panel can be attached to , to give the snap shadow
                            let values = SnapPanel.snapCal(i, p);
                            // console.log(values,'values');
                            if (!foundMatch) {
                                if (values.x > 20 && values.y > 20) {

                                    console.log('match found x and y axis', values.x, values.y);
                                    foundMatch = true;
                                    //shadow on match found near by panel , drop on that place
                                    if (shape == null) {
                                        shape = konva.getCanvasRect({
                                            x: values.x,
                                            y: values.y,
                                            width: values.w,
                                            height: values.h,
                                            fill: 'rgb(255, 255, 255,0.5)',
                                        });
                                        DrawRoofForPanel.layerRoof.add(shape);
                                        shape.draw();
                                    } else {
                                        shape.x(values.x);
                                        shape.y(values.y);
                                    }
                                } else {
                                    if (shape) {
                                        shape.destroy();
                                    }
                                    shape = null;
                                }
                            }
                        });
                    }
                }


                //Cancel the panel drop before you drop it if you want using esc key.
                if (DrawRoofForPanel.isEscapeKeyPressed) {
                    DrawRoofForPanel.isEscapeKeyPressed = false;
                    //
                    // console.log('escape event tempOnDragMove',tempOnDragMove);
                    if (tempOnDragMove) {
                        tempOnDragMove.destroy();
                        tempOnDragMove = null;
                        this.layerPanel.batchDraw();
                        Global.dragDropModules.allowPanelonRoof = false;
                    }
                    if (shape) {
                        shape.destroy();
                        shape = null;
                    }

                }


                this.layerRoof.batchDraw();
                this.layerPanel.batchDraw();


            }
        });
        //mouse hold function to delete the panle on escape key
        // con.addEventListener('mousedown', (e: any) => {

        //code triggers on hold
        // console.log('mouse hold');
        //Cancel the panel drop before you drop it if you want using esc key.
        //if(DrawRoofForPanel.isEscapeKeyPressed){
        //  DrawRoofForPanel.isEscapeKeyPressed = false;
        //
        // console.log('escape event tempOnDragMove',tempOnDragMove);
        //   if (tempOnDragMove) {
        //        tempOnDragMove.destroy();
        //       tempOnDragMove = null;
        //       this.layerPanel.batchDraw();
        //         Global.dragDropModules.allowPanelonRoof = false;
        //    }
        //    if (shape) {
        //       shape.destroy();
        //        shape = null;
        //    }

        // }


        // });

        // while panels drop on roof - drop event
        con.addEventListener('mouseup', (e: any) => {
            //console.log('coming ');


            if (Global.dragDropModules.allowPanelonRoof) {
                //Cancel the panel drop before you drop it if you want using esc key.
                //console.log('cancel on mouse up');
                if (DrawRoofForPanel.isEscapeKeyPressed) {
                    DrawRoofForPanel.isEscapeKeyPressed = false;
                    //
                    // console.log('escape event tempOnDragMove',tempOnDragMove);
                    if (tempOnDragMove) {
                        tempOnDragMove.destroy();
                        tempOnDragMove = null;
                        this.layerPanel.batchDraw();
                        Global.dragDropModules.allowPanelonRoof = false;
                    }
                    if (shape) {
                        shape.destroy();
                        shape = null;
                    }

                } else {
                    let a = null, b = null;
                    if (shape != null) {
                        a = shape.getX();
                        b = shape.getY();
                        shape.destroy();
                        shape = null;
                        this.layerRoof.batchDraw();
                    }

                    var rows = Global.dragDropModules.rows;
                    var columns = Global.dragDropModules.columns;

                    e.preventDefault();
                    this.stage.setPointersPositions(e);
                    var mousePos: any = this.stage.getPointerPosition();
                    var x1: number, y1: number;
                    var width = columns * ModWidth + (columns - 1) * Sol50.nHorizontalAbstand;
                    var height = rows * ModHeight + (rows - 1) * Sol50.nVertikalAbstand;
                    x1 = a ? a : (mousePos.x - DrawRoofForPanel.stage.x()) * 1 / this.currentScale - ModWidth / 2;
                    y1 = b ? b : (mousePos.y - DrawRoofForPanel.stage.y()) * 1 / this.currentScale - ModHeight / 2;
                    // console.log('x1,y1',x1,y1);

                    let overlapping = false;
                    var haveIntersection = (r1: any, r2: any) => {
                        return !(
                            r2.x > r1.x + r1.width ||
                            r2.x + r2.width < r1.x ||
                            r2.y > r1.y + r1.height ||
                            r2.y + r2.height < r1.y
                        );
                    };
                    // const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
                    // if (nonUsableArea && nonUsableArea.length > 0) {
                    //     nonUsableArea.forEach((item: any) => {
                    //         // console.log(item.getClientRect());
                    //         if (haveIntersection(item.getClientRect(),{ x: x1 * this.currentScale, y: y1 * this.currentScale, width: width * this.currentScale, height: height * this.currentScale })) {
                    //         //   console.log(nonUsableArea > x1 && y1);

                    //                overlapping = true;
                    //         }
                    //     });
                    // }
                    const start = 100 * DrawRoofForPanel.currentScale;
                    let obj = { x: 0, y: 0 };
                    let w = RoofShape.getCurrentRoofWidth() * DrawRoofForPanel.currentScale;
                    let h = RoofShape.getCurrentRoofHeight() * DrawRoofForPanel.currentScale;
                    let w1 = RoofShape.getCurrentRoofWidth() + 100;
                    let h1 = RoofShape.getCurrentRoofHeight() + 100;

                    // if ((x1) < 100) {
                    //     overlapping = true;
                    // }
                    // if ((y1) < 100) {
                    //     overlapping = true;
                    // }
                    // if ((x1 + width) > w1) {
                    //     overlapping = true;
                    // }
                    // if ((y1 + height) > h1) {
                    //     overlapping = true;
                    // }


                    const list: any[] = [];
                    const ya = y1;
                    for (let i = 1; i <= rows; i++) {
                        let x = x1;
                        for (let j = 1; j <= columns; j++) {
                            list.push({ x: x, y: y1, width: ModWidth, height: ModHeight });
                            x = x + ModWidth + Sol50.nHorizontalAbstand;
                        }
                        y1 = y1 + ModHeight + Sol50.nVertikalAbstand;
                    }
                    let allPanels: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
                    allPanels.forEach((group: any) => {
                        for (let k = 0; k < list.length; k++) {
                            if (this.haveIntersection(group.getAttrs(), list[k])) {
                                overlapping = true;
                            }
                        }
                    });

                    if (this.checkIsInRange(x1, ya, width, height) && !overlapping) {
                        Modul.isPanelMoved = true;
                        ModGroup.addGroupOfModuls(rows, columns, a ? a : x1, b ? b : ya, DrawRoofForPanel.panelGroup, ModWidth, ModHeight);
                    }


                    this.layerPanel.batchDraw();

                    Global.dragDropModules.allowPanelonRoof = false;
                    if (tempOnDragMove) {
                        setTimeout(() => {
                            tempOnDragMove.destroy();
                            tempOnDragMove = null;
                            this.layerPanel.batchDraw();
                        }, 1);
                    }
                }

            }


        });
    }

    static haveIntersection(r1: any, r2: any) {
        return !(
            r2.x > r1.x + r1.width ||
            r2.x + r2.width < r1.x ||
            r2.y > r1.y + r1.height ||
            r2.y + r2.height < r1.y
        );
    }

    static checkIsInRange(x1: number, y1: number, width: number, height: number) {
        var xValues: any = [x1, x1 + width], yValues: any = [y1, y1 + height];
        var temp = [];
        var list: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        if (list && list.length > 0) {
            list.forEach((obj: any) => {
                if (obj) {
                    var x = obj.getAttrs().x;
                    var y = obj.getAttrs().y;
                    var w = obj.getAttrs().width;
                    var h = obj.getAttrs().height;
                    var minX = xValues[0] > xValues[1] ? xValues[1] : xValues[0];
                    var maxX = xValues[0] < xValues[1] ? xValues[1] : xValues[0];
                    var minY = yValues[0] > yValues[1] ? yValues[1] : yValues[0];
                    var maxY = yValues[0] < yValues[1] ? yValues[1] : yValues[0];

                    var panelIsInRange = false;
                    if (x > minX && x < maxX && y > minY && y < maxY) {
                        panelIsInRange = true;
                    }
                    if ((x + w) > minX && (x + w) < maxX && y > minY && y < maxY) {
                        panelIsInRange = true;
                    }
                    if ((x + w) > minX && (x + w) < maxX && (y + h) > minY && (y + h) < maxY) {
                        panelIsInRange = true;
                    }
                    if ((x + w) > minX && (x + w) < maxX && (y + h) > minY && (y + h) < maxY) {
                        panelIsInRange = true;
                    }
                    if (panelIsInRange) {
                        temp.push('');
                    }
                }
            });
        }
        return temp.length == 0;
    }

    static drawModules(): void {
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            MountingSystem.fitRechteck();
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            MountingSystem.fitRechteck();
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            MountingSystem.fitWalm();
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            MountingSystem.fitRechteck();
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            MountingSystem.fitKrueppelwalm();
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            MountingSystem.fitRechteck();
        }
        DrawRoofForPanel.layerPanel.batchDraw();
        setTimeout(() => {
            // MountingSystem.checkCantilever();
            const nonUsableArea: any = DrawRoofForPanel.layerPanel.find('.' + Global.nonUsableArea);
            if (nonUsableArea && nonUsableArea.length > 0) {
                DrawFence.doClearPanels = true;
            } else {
                DrawRoofForPanel.layerPanel.batchDraw();
            }
        }, 100);
        Global.roofWidth = RoofShape.getCurrentRoofWidth();
        Global.roofHeight = RoofShape.getCurrentRoofHeight();
    }

    static drawMesurments() {
        // console.log(Global.panelRows);
        let roofXmin: any;
        let roofXmax: any = 0;
        let roofXmaxEnd: any = 0;
        let roofYmin: any;
        let roofYmax: any = 0;
        let roofYmaxEnd: any = 0;
        const panelWidth = (SC_Input.nModWidth / 10);
        const panelHeight = (SC_Input.nModHeight / 10);
        // panelRows.forEach((panel: any, index: number) => {
        let count = 0;
        let w = panelWidth;
        let h = panelHeight;

        Global.panelRows.forEach((row: any) => {

            if (row.portrait) {
                w = panelWidth;
                h = panelHeight;
            } else {
                w = panelHeight;
                h = panelWidth;
            }
            const t = row.x + ((row.space) * (row.panelCount - 1)) + ((w) * row.panelCount);
            if (roofXmaxEnd < t) {
                roofXmaxEnd = t;
            }

            if (!roofXmin) {
                roofXmin = row.x;
            } else if (roofXmin > row.x) {
                roofXmin = row.x;
            }

            if (roofYmax < row.y) {
                roofYmax = row.y;
                roofYmaxEnd = row.y + (h);
            }
            if (!roofYmin) {
                roofYmin = row.y;
            } else if (roofYmin > row.y) {
                roofYmin = row.y;
            }
        });

        const nRoofHeight = RoofShape.getCurrentRoofHeight() + 100;
        const nRoofWidth = RoofShape.getCurrentRoofWidth() + 100;

        var lineXStart = konva.getCanvasLine({
            points: [roofXmin, nRoofHeight - 80, roofXmin, nRoofHeight],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineXEnd = konva.getCanvasLine({
            points: [roofXmaxEnd, nRoofHeight - 80, roofXmaxEnd, nRoofHeight],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineX = konva.getCanvasLine({
            points: [roofXmin, nRoofHeight - 80, roofXmaxEnd, nRoofHeight - 80],
            stroke: '#000',
            strokeWidth: 5,
        });
        var arrow1x = new Konva.Arrow({
            points: [roofXmin, nRoofHeight - 40, roofXmaxEnd, nRoofHeight - 40],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        var arrow2x = new Konva.Arrow({
            points: [roofXmaxEnd, nRoofHeight - 40, roofXmin, nRoofHeight - 40],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        var lineXtext = konva.getCanvasText({
            x: (roofXmin + roofXmaxEnd) / 2,
            y: nRoofHeight - 20,
            text: (roofXmaxEnd - roofXmin).toFixed(2) + 'cm',
            fontSize: 60,
            fontFamily: 'Calibri',
            fill: '#000',
        });
        var rect = new Konva.Rect({
            x: lineXtext.x() - 10,
            y: lineXtext.y() - 10,
            fill: '#fff',
            width: lineXtext.width() + 20,
            height: lineXtext.height() + 20,
            cornerRadius: 10,
        });
        this.panelGroup.add(lineXEnd, lineXStart, arrow2x, arrow1x, rect, lineXtext);
        lineXStart.draw();
        lineXEnd.draw();
        lineXtext.draw();
        arrow1x.draw();
        arrow2x.draw();

        var lineYStart = konva.getCanvasLine({
            points: [nRoofWidth - 100, roofYmin, nRoofWidth, roofYmin],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineYEnd = konva.getCanvasLine({
            points: [nRoofWidth - 100, roofYmaxEnd, nRoofWidth, roofYmaxEnd],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineY = konva.getCanvasLine({
            points: [nRoofWidth - 80, roofYmin, nRoofWidth - 80, roofYmaxEnd],
            stroke: '#000',
            strokeWidth: 5,
        });
        var arrow1 = new Konva.Arrow({
            points: [nRoofWidth - 50, roofYmin, nRoofWidth - 50, roofYmaxEnd],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        var arrow2 = new Konva.Arrow({
            points: [nRoofWidth - 50, roofYmaxEnd, nRoofWidth - 50, roofYmin],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        var lineYtext = konva.getCanvasText({
            x: nRoofWidth - 30,
            y: (roofYmin + roofYmaxEnd) / 2,
            text: (roofYmaxEnd - roofYmin).toFixed(2) + 'cm',
            fontSize: 60,
            fontFamily: 'Calibri',
            fill: '#000',
        });
        var rect2 = new Konva.Rect({
            x: lineYtext.x() - 10,
            y: lineYtext.y() + lineYtext.height() / 2,
            fill: '#fff',
            width: lineYtext.width() + 40,
            height: lineYtext.height() + 10,
            cornerRadius: 10,
        });

        rect2.rotate(270);
        lineYtext.rotate(270);
        this.panelGroup.add(lineYEnd, lineYStart, arrow1, arrow2, rect2, lineYtext);
        lineYStart.draw();
        lineYEnd.draw();
        //lineY.draw();
        lineYtext.draw();
        arrow1.draw();
        arrow2.draw();

    }

    static subframeMesurment() {
        // console.log(Sol50OnRoof.aVProfile);
        // console.log(Global.aHProfile);
        let roofXmin: any;
        let roofXmax: any = 0;
        let roofYmin: any;
        let roofYmax: any = 0;
        let roofXmaxEnd: any = 0;
        let roofYmaxEnd: any = 0;
        const panelWidth = (SC_Input.nModWidth / 10);
        const panelHeight = (SC_Input.nModHeight / 10);
        // panelRows.forEach((panel: any, index: number) => {
        let count = 0;
        let w = panelWidth;
        let h = panelHeight;

        Global.panelRows.forEach((row: any) => {
            // console.log(row)
            if (row.portrait) {
                w = panelWidth;
                h = panelHeight;
            } else {
                w = panelHeight;
                h = panelWidth;
            }
            const t = row.x + ((row.space) * (row.panelCount - 1)) + ((w) * row.panelCount);
            if (roofXmaxEnd < t) {
                roofXmaxEnd = t;
            }
            // if (roofXmax < row.x) {
            //     roofXmax = row.x;
            // }
            if (!roofXmin) {
                roofXmin = row.x;
            } else if (roofXmin > row.x) {
                roofXmin = row.x;
            }
            // console.log(roofXmax, roofXmin, roofXmaxEnd)

            if (roofYmax < row.y) {
                roofYmax = row.y;
                roofYmaxEnd = row.y + (h);
            }
            if (!roofYmin) {
                roofYmin = row.y;
            } else if (roofYmin > row.y) {
                roofYmin = row.y;
            }
            //console.log("Trape",roofYmin, roofYmax, roofYmaxEnd)
        });


        if (Global.aHProfile.length > 0) {
            Global.aHProfile.forEach((vline: any) => {
                if (roofXmax < vline.r) {
                    roofXmax = vline.r;
                    // roofXmaxEnd = row.x + ((SC_Input.nModWidth / 10 + row.space) * row.panelCount);
                }
                if (!roofXmin) {
                    roofXmin = vline.l;
                } else if (roofXmin > vline.l) {
                    roofXmin = vline.l;
                }
            });
        }

        const nRoofHeight = RoofShape.getCurrentRoofHeight() + 100;
        const nRoofWidth = RoofShape.getCurrentRoofWidth() + 100;

        var lineXStart = konva.getCanvasLine({
            points: [roofXmin, nRoofHeight - 80, roofXmin, nRoofHeight],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineXEnd = konva.getCanvasLine({
            points: [roofXmaxEnd, nRoofHeight - 80, roofXmaxEnd, nRoofHeight],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineX = konva.getCanvasLine({
            points: [roofXmin, nRoofHeight - 60, roofXmaxEnd, nRoofHeight - 60],
            stroke: '#000',
            strokeWidth: 5,
        });
        var lineXtext = konva.getCanvasText({
            x: (roofXmin + roofXmaxEnd) / 2,
            y: nRoofHeight - 40,
            text: (roofXmaxEnd - roofXmin).toFixed(2) + 'cm',
            fontSize: 60,
            fontFamily: 'Calibri',
            fill: '#000',
        });
        var rect = new Konva.Rect({
            x: lineXtext.x() - 10,
            y: lineXtext.y() - 10,
            fill: '#fff',
            width: lineXtext.width() + 20,
            height: lineXtext.height() + 20,
            cornerRadius: 10,
        });
        var arrow1x = new Konva.Arrow({
            points: [roofXmin, nRoofHeight - 40, roofXmaxEnd, nRoofHeight - 40],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        var arrow2x = new Konva.Arrow({
            points: [roofXmaxEnd, nRoofHeight - 40, roofXmin, nRoofHeight - 40],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        this.subframeGroup.add(lineXEnd, lineXStart, arrow2x, arrow1x, rect, lineXtext);
        lineXStart.draw();
        lineXEnd.draw();
        lineXtext.draw();
        arrow2x.draw();
        arrow1x.draw();

        if (SC_Input.iRoofType != 1) {
            if (Sol50OnRoof.aVProfile.length > 0) {
                Sol50OnRoof.aVProfile.forEach((vline: any) => {
                    if (roofYmax < vline.b) {
                        roofYmax = vline.b;
                    }
                    if (!roofYmin) {
                        roofYmin = vline.t;
                    } else if (roofYmin > vline.t) {
                        roofYmin = vline.t;
                    }

                });
            } else if (Sol50Integrated.aVGroups.length > 0) {
                Sol50Integrated.aVGroups.forEach((vline: any) => {
                    if (roofYmax < vline.b) {
                        roofYmax = vline.b;
                    }
                    if (!roofYmin) {
                        roofYmin = vline.t;
                    } else if (roofYmin > vline.t) {
                        roofYmin = vline.t;
                    }
                });
            }
        }

        var lineYStart = konva.getCanvasLine({
            points: [nRoofWidth - 100, roofYmin, nRoofWidth, roofYmin],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineYEnd = konva.getCanvasLine({
            points: [nRoofWidth - 100, roofYmaxEnd, nRoofWidth, roofYmaxEnd],
            stroke: '#000',
            strokeWidth: 5,
        });

        var lineY = konva.getCanvasLine({
            points: [nRoofWidth - 60, roofYmin, nRoofWidth - 60, roofYmaxEnd],
            stroke: '#000',
            strokeWidth: 5,
        });
        var lineYtext = konva.getCanvasText({
            x: nRoofWidth - 50,
            y: (roofYmin + roofYmaxEnd) / 2,
            text: (roofYmaxEnd - roofYmin).toFixed(2) + 'cm',
            fontSize: 60,
            fontFamily: 'Calibri',
            fill: '#000',
        });

        var rect2 = new Konva.Rect({
            x: lineYtext.x() - 10,
            y: lineYtext.y() + lineYtext.height() / 2,
            fill: '#fff',
            width: lineYtext.width() + 40,
            height: lineYtext.height() + 10,
            cornerRadius: 10,
        });
        var arrow1 = new Konva.Arrow({
            points: [nRoofWidth - 50, roofYmin, nRoofWidth - 50, roofYmaxEnd],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        var arrow2 = new Konva.Arrow({
            points: [nRoofWidth - 50, roofYmaxEnd, nRoofWidth - 50, roofYmin],
            pointerLength: 20,
            pointerWidth: 20,
            fill: 'black',
            stroke: 'black',
            strokeWidth: 5,
        });
        rect2.rotate(270);
        lineYtext.rotate(270);
        this.subframeGroup.add(lineYEnd, lineYStart, arrow1, arrow2, rect2, lineYtext);
        lineYStart.draw();
        lineYEnd.draw();
        lineYtext.draw();
        arrow1.draw();
        arrow2.draw();
    }

}
